import { render, staticRenderFns } from "./AppTour.vue?vue&type=template&id=135663e2&scoped=true"
import script from "./AppTour.vue?vue&type=script&lang=js"
export * from "./AppTour.vue?vue&type=script&lang=js"
import style0 from "./AppTour.vue?vue&type=style&index=0&id=135663e2&prod&lang=scss"
import style1 from "./AppTour.vue?vue&type=style&index=1&id=135663e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135663e2",
  null
  
)

export default component.exports